import { queryToString } from '@shared/helpers/api-utils';
import axios from '@shared/helpers/axios';

export const apiPath = 'api/v2/chat-rooms';

const chatRoomApi = {
    index: (query: Record<string, any>, memberId: number) => {
        // Match public frontend exactly:
        // `${util.queryToString(query)}&findBy[]=diffOr&orValue[]=userAId,${memberId},number&orValue[]=userBId,${memberId},number`
        const baseQueryStr = queryToString(query);
        const _url = `${process.env.REACT_APP_API_URL}/${apiPath}/index?${baseQueryStr}&findBy[]=diffOr&orValue[]=userAId,${memberId},number&orValue[]=userBId,${memberId},number`;

        return axios.get(_url);
    },
    createRoom: (entity: Record<string, any>) => {
        return axios.post(`${process.env.REACT_APP_API_URL}/${apiPath}/create-room`, {
            ...entity,
        });
    },
};

export default chatRoomApi;
